/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, IWrapHTTPConfig } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EmptyResponse } from '../models/empty-response';
import { ResponsePageableListDtoUserDto } from '../models/response-pageable-list-dto-user-dto';
import { ResponseString } from '../models/response-string';
import { ResponseUserCreateDto } from '../models/response-user-create-dto';
import { ResponseUserDto } from '../models/response-user-dto';
import { ResponseUserPasswordDto } from '../models/response-user-password-dto';
import { UserCreateForm } from '../models/user-create-form';
import { UserPasswordForm } from '../models/user-password-form';
import { UserSearchForm } from '../models/user-search-form';
import { UserSearchLocalForm } from '../models/user-search-local-form';
import { UserUpdateForm } from '../models/user-update-form';

@Injectable({
  providedIn: 'root',
})
export class AdminUsersApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation updateUserPassword
   */
  static readonly UpdateUserPasswordPath = '/api/v1/admin/users/{userId}/password';

  /**
   * Update user's password
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  private updateUserPassword$Response(params: {
    userId: number;
    body: UserPasswordForm
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<ResponseUserPasswordDto>> {

    const rb = new RequestBuilder(this.rootUrl, AdminUsersApiService.UpdateUserPasswordPath, 'put');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResponseUserPasswordDto>;
      })
    );
  }

  /**
   * Update user's password
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateUserPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserPassword(params: {
    userId: number;
    body: UserPasswordForm
  }, config?: IWrapHTTPConfig
): Observable<ResponseUserPasswordDto> {

    return this.wrapHTTPQuery(this.updateUserPassword$Response(params, config).pipe(
      map((r: StrictHttpResponse<ResponseUserPasswordDto>) => r.body as ResponseUserPasswordDto)
    ), config);
  }

  /**
   * Path part for operation getUser
   */
  static readonly GetUserPath = '/api/v1/admin/users/{userId}';

  /**
   * Get user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  private getUser$Response(params: {
    userId: number;
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<ResponseUserDto>> {

    const rb = new RequestBuilder(this.rootUrl, AdminUsersApiService.GetUserPath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResponseUserDto>;
      })
    );
  }

  /**
   * Get user
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUser(params: {
    userId: number;
  }, config?: IWrapHTTPConfig
): Observable<ResponseUserDto> {

    return this.wrapHTTPQuery(this.getUser$Response(params, config).pipe(
      map((r: StrictHttpResponse<ResponseUserDto>) => r.body as ResponseUserDto)
    ), config);
  }

  /**
   * Path part for operation updateUser
   */
  static readonly UpdateUserPath = '/api/v1/admin/users/{userId}';

  /**
   * Update user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  private updateUser$Response(params: {
    userId: number;
    body: UserUpdateForm
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<ResponseUserDto>> {

    const rb = new RequestBuilder(this.rootUrl, AdminUsersApiService.UpdateUserPath, 'put');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResponseUserDto>;
      })
    );
  }

  /**
   * Update user
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUser(params: {
    userId: number;
    body: UserUpdateForm
  }, config?: IWrapHTTPConfig
): Observable<ResponseUserDto> {

    return this.wrapHTTPQuery(this.updateUser$Response(params, config).pipe(
      map((r: StrictHttpResponse<ResponseUserDto>) => r.body as ResponseUserDto)
    ), config);
  }

  /**
   * Path part for operation deleteUser
   */
  static readonly DeleteUserPath = '/api/v1/admin/users/{userId}';

  /**
   * Delete user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  private deleteUser$Response(params: {
    userId: number;
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<EmptyResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdminUsersApiService.DeleteUserPath, 'delete');
    if (params) {
      rb.path('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmptyResponse>;
      })
    );
  }

  /**
   * Delete user
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUser(params: {
    userId: number;
  }, config?: IWrapHTTPConfig
): Observable<EmptyResponse> {

    return this.wrapHTTPQuery(this.deleteUser$Response(params, config).pipe(
      map((r: StrictHttpResponse<EmptyResponse>) => r.body as EmptyResponse)
    ), config);
  }

  /**
   * Path part for operation searchLocalUsers
   */
  static readonly SearchLocalUsersPath = '/api/v1/admin/users/search/local';

  /**
   * Search local users
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchLocalUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  private searchLocalUsers$Response(params: {
    body: UserSearchLocalForm
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<ResponsePageableListDtoUserDto>> {

    const rb = new RequestBuilder(this.rootUrl, AdminUsersApiService.SearchLocalUsersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResponsePageableListDtoUserDto>;
      })
    );
  }

  /**
   * Search local users
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `searchLocalUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchLocalUsers(params: {
    body: UserSearchLocalForm
  }, config?: IWrapHTTPConfig
): Observable<ResponsePageableListDtoUserDto> {

    return this.wrapHTTPQuery(this.searchLocalUsers$Response(params, config).pipe(
      map((r: StrictHttpResponse<ResponsePageableListDtoUserDto>) => r.body as ResponsePageableListDtoUserDto)
    ), config);
  }

  /**
   * Path part for operation searchUsers
   */
  static readonly SearchUsersPath = '/api/v1/admin/users/search';

  /**
   * Search users
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  private searchUsers$Response(params: {
    body: UserSearchForm
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<ResponsePageableListDtoUserDto>> {

    const rb = new RequestBuilder(this.rootUrl, AdminUsersApiService.SearchUsersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResponsePageableListDtoUserDto>;
      })
    );
  }

  /**
   * Search users
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `searchUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchUsers(params: {
    body: UserSearchForm
  }, config?: IWrapHTTPConfig
): Observable<ResponsePageableListDtoUserDto> {

    return this.wrapHTTPQuery(this.searchUsers$Response(params, config).pipe(
      map((r: StrictHttpResponse<ResponsePageableListDtoUserDto>) => r.body as ResponsePageableListDtoUserDto)
    ), config);
  }

  /**
   * Path part for operation createUser
   */
  static readonly CreateUserPath = '/api/v1/admin/users';

  /**
   * Create user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  private createUser$Response(params: {
    body: UserCreateForm
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<ResponseUserCreateDto>> {

    const rb = new RequestBuilder(this.rootUrl, AdminUsersApiService.CreateUserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResponseUserCreateDto>;
      })
    );
  }

  /**
   * Create user
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUser(params: {
    body: UserCreateForm
  }, config?: IWrapHTTPConfig
): Observable<ResponseUserCreateDto> {

    return this.wrapHTTPQuery(this.createUser$Response(params, config).pipe(
      map((r: StrictHttpResponse<ResponseUserCreateDto>) => r.body as ResponseUserCreateDto)
    ), config);
  }

  /**
   * Path part for operation newPassword
   */
  static readonly NewPasswordPath = '/api/v1/admin/users/password/new';

  /**
   * New password
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newPassword()` instead.
   *
   * This method doesn't expect any request body.
   */
  private newPassword$Response(params?: {
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<ResponseString>> {

    const rb = new RequestBuilder(this.rootUrl, AdminUsersApiService.NewPasswordPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResponseString>;
      })
    );
  }

  /**
   * New password
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `newPassword$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newPassword(params?: {
  }, config?: IWrapHTTPConfig
): Observable<ResponseString> {

    return this.wrapHTTPQuery(this.newPassword$Response(params, config).pipe(
      map((r: StrictHttpResponse<ResponseString>) => r.body as ResponseString)
    ), config);
  }

}
